module.exports = __webpack_public_path__ + "images/171e63a6975ee09908d6893be75a27c1b.svg";